export const QA_TURNSTILE_BYPASS_EMAIL_DOMAIN = "abhc91kk.mailosaur.net";

export function isQATurnstileBypassEmail(email) {
  if (typeof email !== "string") {
    return false;
  }

  const normalizedEmail = email.trim().toLowerCase();
  const parts = normalizedEmail.split("@");
  if (parts.length !== 2) {
    return false;
  }

  return parts[1] === QA_TURNSTILE_BYPASS_EMAIL_DOMAIN;
}
